module.exports = "<!--ADD ALPHABETICAL ORDER AND NOT CAPITAL!!!!!-->\n<div *ngFor=\"let content of contentList\">\n    <a [routerLink]=\"['/'+this.getContentPath(content.contentType), content.contentID]\" class=\"listPageListHyperlinkItems\">\n        {{content.contentTitle}} | {{content.contentSubTitle}}\n    </a>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/listContent/listContent.component.html
// module id = ../../../../../src/app/components/listContent/listContent.component.html
// module chunks = main